import React, { useState } from 'react';
import googlePay from '../assets/logo/Google_Pay.png';
import applePay from '../assets/logo/Apple_Pay.png';
import binance from '../assets/logo/Binance_Logo.svg.png';
import bancontact from '../assets/logo/Bancontact.png';
import mastercard from '../assets/logo/Mastercard.png';
import visa from '../assets/logo/Visa.png';
import {Infinity} from 'lucide-react'

const pricingData = {
    standard: [
        {
            name: "PLANO BÁSICO", 
            price: "20.00", 
            duration: "3 MESES", 
            link: "https://toptemplate.store/order.php?id=20", 
            features: [
                "+79.000 Canais, +249.000 Filmes e Séries.",
                "Netflix, Disney+, Amazon Prime Video, HBO Max, OCS, Paramount+, Apple+, Discovery+",
                "Liga Portugal + Portugal em FULL HD / 4K",
                "Escolha ilimitada de Filmes & Séries",
                "Qualidade 4K / FULL HD / HD / SD",
                "Catch-up e EPG",
                "Servidores Rápidos e Estáveis",
                "Compatível com todos os dispositivos",
                "Conteúdo regularmente atualizado",
                "15 Dias Garantia de Reembolso"
            ] 
        },
        {
            name: "PLANO BÁSICO", 
            price: "29.00", 
            duration: "12 MESES", 
            link: "https://toptemplate.store/order.php?id=29", 
            isPopular: true, 
            badge: "MAIS POPULAR", 
            features: [
                "Canais + Filmes Para Adultos 🔞",
                "+79.000 Canais, +249.000 Filmes e Séries.",
                "Netflix, Disney+, Amazon Prime Video, HBO Max, OCS, Paramount+, Apple+, Discovery+",
                "Liga Portugal + Portugal em FULL HD / 4K",
                "Escolha ilimitada de Filmes & Séries",
                "Qualidade 4K / FULL HD / HD / SD",
                "Catch-up e EPG",
                "Servidores Rápidos e Estáveis",
                "Compatível com todos os dispositivos",
                "Conteúdo regularmente atualizado",
                "15 Dias Garantia de Reembolso"
            ] 
        },
        { 
            name: "PLANO PREMIUM", 
            price: "39.00", 
            duration: "24 MESES", 
            link: "https://toptemplate.store/order.php?id=49", 
            badge: "MELHOR PREÇO", 
            screens: 1, 
            features: [
                "Canais + Filmes Para Adultos 🔞",
                "+79.000 Canais, +249.000 Filmes e Séries.",
                "Netflix, Disney+, Amazon Prime Video, HBO Max, OCS, Paramount+, Apple+, Discovery+",
                "Liga Portugal + Portugal em FULL HD / 4K",
                "Escolha ilimitada de Filmes & Séries",
                "Qualidade 4K / FULL HD / HD / SD",
                "Catch-up e EPG",
                "Servidores Rápidos e Estáveis",
                "Compatível com todos os dispositivos",
                "Conteúdo regularmente atualizado",
                "15 Dias Garantia de Reembolso"
            ] 
        }
    ],
    multiScreen: [
        { 
            name: "PLANO GOLD", 
            price: "49.00", 
            duration: "16 MESES", 
            link: "https://toptemplate.store/order.php?id=49", 
            screens: 2, 
            features: [
                "Dois ecrãs ativos",
                "+79.000 Canais, +249.000 Filmes e Séries.",
                "Netflix, Disney+, Amazon Prime Video, HBO Max, OCS, Paramount+, Apple+, Discovery+",
                "Liga Portugal + Portugal em FULL HD / 4K",
                "Escolha ilimitada de Filmes & Séries",
                "Qualidade 4K / FULL HD / HD / SD",
                "Catch-up e EPG",
                "Servidores Rápidos e Estáveis",
                "Compatível com todos os dispositivos",
                "Conteúdo regularmente atualizado",
                "15 Dias Garantia de Reembolso"
            ] 
        },
        { 
            name: "PLANO PLATINUM", 
            price: "69.00", 
            duration: "16 MESES", 
            link: "https://toptemplate.store/order.php?id=69", 
            isPopular: true, 
            badge: "MAIS POPULAR", 
            screens: 3, 
            features: [
                "Três ecrãs ativos",
                "Canais + Filmes Para Adultos 🔞",
                "+79.000 Canais, +249.000 Filmes e Séries.",
                "Netflix, Disney+, Amazon Prime Video, HBO Max, OCS, Paramount+, Apple+, Discovery+",
                "Liga Portugal + Portugal em FULL HD / 4K",
                "Escolha ilimitada de Filmes & Séries",
                "Qualidade 4K / FULL HD / HD / SD",
                "Catch-up e EPG",
                "Servidores Rápidos e Estáveis",
                "Compatível com todos os dispositivos",
                "Conteúdo regularmente atualizado",
                "15 Dias Garantia de Reembolso"
            ] 
        },
        { 
            name: "PLANO DIAMANTE", 
            price: "89.00", 
            duration: "16 MESES", 
            link: "https://toptemplate.store/order.php?id=89", 
            badge: "MELHOR PREÇO", 
            screens: 4, 
            features: [
                "Quatro ecrãs ativos",
                "Canais + Filmes Para Adultos 🔞",
                "+79.000 Canais, +249.000 Filmes e Séries.",
                "Netflix, Disney+, Amazon Prime Video, HBO Max, OCS, Paramount+, Apple+, Discovery+",
                "Liga Portugal + Portugal em FULL HD / 4K",
                "Escolha ilimitada de Filmes & Séries",
                "Qualidade 4K / FULL HD / HD / SD",
                "Catch-up e EPG",
                "Servidores Rápidos e Estáveis",
                "Compatível com todos os dispositivos",
                "Conteúdo regularmente atualizado",
                "15 Dias Garantia de Reembolso"
            ] 
        }
    ]
};

export default function Pricing() {
    const [isMultiScreen, setIsMultiScreen] = useState(false);
    const paymentLogos = [
        { src: applePay, alt: 'USDT', useFilter: false },
        { src: googlePay, alt: 'PayPal', useFilter: false },
        { src: visa, alt: 'Visa', useFilter: false },
        { src: mastercard, alt: 'Mastercard', useFilter: false },
        { src: bancontact, alt: 'Bancontact', useFilter: false },
        { src: binance, alt: 'Binance', useFilter: false }
    ];

    const currentPlans = isMultiScreen ? pricingData.multiScreen : pricingData.standard;

    return (
        <section className="py-20 relative overflow-hidden">
            {/* Background Pattern */}
            <div className="absolute inset-0 opacity-5">
                <div className="absolute inset-0" style={{
                    backgroundImage: `radial-gradient(circle at 25% 25%, rgba(255, 184, 0, 0.1) 0%, transparent 50%),
                                    radial-gradient(circle at 75% 75%, rgba(255, 184, 0, 0.1) 0%, transparent 50%)`,
                }}></div>
            </div>
            
            <div className="container mx-auto px-3 sm:px-5 relative z-10">
                {/* Top Banner - IBO Player Gratuit */}
                <div className="mb-16 animate-slide-in-bottom">
                    <div className="relative overflow-hidden rounded-3xl bg-gradient-to-r from-yellow-400/10 via-yellow-400/5 to-blue-500/10 border border-yellow-400/30 backdrop-blur-md p-6 md:p-8 shadow-2xl">
                        {/* Animated Background Pattern */}
                        <div className="absolute inset-0 opacity-10">
                            <div className="absolute inset-0" style={{
                                backgroundImage: `radial-gradient(circle at 20% 50%, rgba(255, 184, 0, 0.3) 0%, transparent 50%),
                                                radial-gradient(circle at 80% 50%, rgba(255, 140, 0, 0.3) 0%, transparent 50%)`,
                            }}></div>
                        </div>
                        
                        <div className="relative z-10 flex flex-col md:flex-row items-center justify-between gap-6">
                            <div className="flex flex-col md:flex-row items-center gap-4 md:gap-6 flex-1">
                                {/* Icon */}
                                <div className="flex-shrink-0 w-16 h-16 md:w-20 md:h-20 bg-yellow-400 rounded-2xl flex items-center justify-center shadow-lg transform hover:scale-110 transition-transform duration-300">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="32px" height="32px" viewBox="0 0 24 24" className="text-black">
                                        <path fill="currentColor" d="M19.435 5.568h-2.38a1.98 1.98 0 0 0-.51-1.92a2.02 2.02 0 0 0-2.83 0L12 5.367l-1.71-1.719a2 2 0 0 0-2.83 0a1.98 1.98 0 0 0-.51 1.92H4.565a1.5 1.5 0 0 0-1.5 1.5v1A1.49 1.49 0 0 0 4 9.448v8.99a2.507 2.507 0 0 0 2.5 2.5h11a2.5 2.5 0 0 0 2.5-2.5v-8.98a1.51 1.51 0 0 0 .94-1.39v-1a1.5 1.5 0 0 0-1.505-1.5M8.165 4.357a1 1 0 0 1 1.41 0l1.21 1.211h-2.77a.99.99 0 0 1 .15-1.211M11 19.938H6.5a1.5 1.5 0 0 1-1.5-1.5v-8.87h6Zm0-11.37H4.565a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5H11Zm3.43-4.211A1 1 0 0 1 16 5.568h-2.78ZM19 18.438a1.5 1.5 0 0 1-1.5 1.5H13V9.568h6Zm.94-10.37a.5.5 0 0 1-.5.5H13v-2h6.44a.5.5 0 0 1 .5.5Z"/>
                                    </svg>
                                </div>
                                
                                {/* Text Content */}
                                <div className="flex-1 text-center md:text-left">
                                    <h3 className="text-2xl md:text-3xl font-bold text-white mb-2">
                                        <span className="text-yellow-400">Leitor IBO Pro</span> Grátis Incluído!
                                    </h3>
                                    <p className="text-gray-200 text-sm md:text-base leading-relaxed">
                                        Com cada plano, receba gratuitamente o leitor IBO Pro premium para desfrutar do seu conteúdo IPTV em todos os seus dispositivos
                                    </p>
                                </div>
                            </div>
                            
                            {/* Badge */}
                            <div className="flex-shrink-0">
                                <div className="text-yellow-400 px-6 py-3 rounded-full font-bold text-sm md:text-base shadow-lg transform hover:scale-105 transition-transform duration-300">
                                    GRÁTIS
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Section Header */}
                <div className="text-center mb-12">
                    <h2 className="text-4xl md:text-5xl font-bold text-white mb-8">
                        Escolha o seu <span className="text-yellow-400">plano</span>
                    </h2>
                    <p className="text-md text-gray-300 max-w-3xl mx-auto leading-relaxed mb-12">
                        Planos flexíveis para todas as suas necessidades de streaming IPTV premium
                    </p>
                    
                    {/* Toggle Switch - Yellow/Orange Theme */}
                    <div className="flex justify-center items-center gap-0 max-w-md mx-auto">
                        <button
                            onClick={() => setIsMultiScreen(false)}
                            className={`flex-1 flex items-center justify-center gap-2 py-3 px-6 rounded-l-full font-semibold transition-all duration-300 ${
                                !isMultiScreen
                                    ? 'bg-gradient-to-r from-yellow-400 to-orange-500 text-black shadow-lg'
                                    : 'bg-white/10 text-gray-400 hover:bg-white/15'
                            }`}
                        >
                            <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <rect x="2" y="3" width="20" height="14" rx="2" stroke="currentColor" strokeWidth="2"/>
                            </svg>
                            <span>Standard</span>
                        </button>
                        <button
                            onClick={() => setIsMultiScreen(true)}
                            className={`flex-1 flex items-center justify-center gap-2 py-3 px-6 rounded-r-full font-semibold transition-all duration-300 ${
                                isMultiScreen
                                    ? 'bg-gradient-to-r from-yellow-400 to-orange-500 text-black shadow-lg'
                                    : 'bg-white/10 text-gray-400 hover:bg-white/15'
                            }`}
                        >
                            <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <rect x="2" y="3" width="8" height="6" rx="1" stroke="currentColor" strokeWidth="2"/>
                                <rect x="14" y="3" width="8" height="6" rx="1" stroke="currentColor" strokeWidth="2"/>
                                <rect x="2" y="12" width="8" height="6" rx="1" stroke="currentColor" strokeWidth="2"/>
                                <rect x="14" y="12" width="8" height="6" rx="1" stroke="currentColor" strokeWidth="2"/>
                            </svg>
                            <span>Multi-ecrãs</span>
                        </button>
                    </div>
                </div>

                {/* Pricing Cards */}
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 w-full mx-auto items-stretch" id="pricing">
                    {currentPlans.map((plan, index) => (
                        <div key={index} className="relative group">
                            <div className={`h-full flex flex-col backdrop-blur-md rounded-3xl p-8 pt-10 mt-4 transition-all duration-500 hover:-translate-y-2 hover:shadow-2xl border relative overflow-hidden ${
                                plan.isPopular 
                                ? 'bg-gradient-to-br from-yellow-400/10 to-orange-500/10 border-yellow-400/30 animate-slide-in-top' 
                                : 'bg-white/10 border-white/10 hover:bg-white/15 ' + (index === 0 ? 'animate-slide-in-left' : 'animate-slide-in-right')
                            }`}>
                                {plan.badge && (
                                    <div className="absolute top-11 right-[-50px] rotate-45 z-0">
                                        <div className="bg-yellow-400 text-black text-xs font-bold uppercase tracking-wide px-14 py-1 shadow-sm">
                                            {plan.badge}
                                        </div>
                                    </div>
                                )}
                                
                                <div className="mb-8">
                                    <h3 className="text-3xl font-bold text-white mb-4">{plan.name}</h3>
                                    <p className="text-gray-300 text-md">Pagamento único - Sem contrato vinculativo</p>
                                </div>

                                <div className="mb-8">
                                    <div className="flex items-baseline">
                                        <span className="text-4xl font-bold text-white">{plan.price}€</span>
                                        <span className="text-gray-400 ml-3 text-lg">/ {plan.duration}</span>
                                    </div>
                                    {plan.isPopular && <p className="text-yellow-400 text-md mt-2 font-semibold">OFERTA LIMITADA</p>}
                                    {plan.screens && (
                                        <div className="flex items-center gap-3 mt-3">
                                            <div className='flex gap-1 items-center'>
                                                {[...Array(plan.screens)].map((_, i) => (
                                                    <svg key={i} xmlns="http://www.w3.org/2000/svg" className="text-yellow-400" width="20px" height="20px" viewBox="0 0 1920 1536">
                                                        <path fill="currentColor" d="M1792 1120V160q0-13-9.5-22.5T1760 128H160q-13 0-22.5 9.5T128 160v960q0 13 9.5 22.5t22.5 9.5h1600q13 0 22.5-9.5t9.5-22.5m128-960v960q0 66-47 113t-113 47h-736v128h352q14 0 23 9t9 23v64q0 14-9 23t-23 9H544q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h352v-128H160q-66 0-113-47T0 1120V160Q0 94 47 47T160 0h1600q66 0 113 47t47 113"/>
                                                    </svg>
                                                ))}
                                            </div>
                                            <span className="text-yellow-400 text-md font-semibold">{plan.screens} ecrãs</span>
                                        </div>
                                    )}
                                </div>

                                <div className="text-yellow-400 rounded-2xl flex items-center justify-center gap-1 w-full py-3 px-6">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24">
                                        <path fill="currentColor" d="M19.435 5.568h-2.38a1.98 1.98 0 0 0-.51-1.92a2.02 2.02 0 0 0-2.83 0L12 5.367l-1.71-1.719a2 2 0 0 0-2.83 0a1.98 1.98 0 0 0-.51 1.92H4.565a1.5 1.5 0 0 0-1.5 1.5v1A1.49 1.49 0 0 0 4 9.448v8.99a2.507 2.507 0 0 0 2.5 2.5h11a2.5 2.5 0 0 0 2.5-2.5v-8.98a1.51 1.51 0 0 0 .94-1.39v-1a1.5 1.5 0 0 0-1.505-1.5M8.165 4.357a1 1 0 0 1 1.41 0l1.21 1.211h-2.77a.99.99 0 0 1 .15-1.211M11 19.938H6.5a1.5 1.5 0 0 1-1.5-1.5v-8.87h6Zm0-11.37H4.565a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5H11Zm3.43-4.211A1 1 0 0 1 16 5.568h-2.78ZM19 18.438a1.5 1.5 0 0 1-1.5 1.5H13V9.568h6Zm.94-10.37a.5.5 0 0 1-.5.5H13v-2h6.44a.5.5 0 0 1 .5.5Z"/>
                                    </svg>
                                    <span className="font-bold text-sm">+ Leitor IBO Pro grátis!</span>
                                </div>

                                <div className="space-y-6 mb-10 mt-10 flex-grow">
                                    {plan.features.map((feature, fIndex) => (
                                        <div key={fIndex} className="flex justify-start items-center gap-4">
                                            <div className="flex items-center justify-center flex-shrink-0">
                                                <svg className="w-5 h-5 text-yellow-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                                    <path fill="currentColor" d="M9 16.17L4.83 12l-1.42 1.41L9 19l12-12l-1.41-1.41z"/>
                                                </svg>
                                            </div>
                                            <span className="text-gray-300 text-base">{feature}</span>
                                        </div>
                                    ))}
                                </div>

                                <button
                                    onClick={() => { window.location.href = plan.link; }}
                                    className={`w-full font-bold py-4 px-8 rounded-full transition-all duration-300 hover:scale-105 shadow-lg ${
                                        plan.isPopular 
                                        ? 'bg-yellow-400 hover:bg-yellow-300 text-black' 
                                        : 'bg-white/10 hover:bg-white/20 text-white border border-white/20 hover:border-white/40'
                                    }`}>
                                    Encomendar agora
                                </button>
                                <div className="mt-4">
                                    <p className="text-white text-sm font-bold text-center">⚠️ Use o seu e-mail em vez do seu nome para receber os seus códigos de acesso e o guia de instalação</p>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>

                {/* FORFAIT LIFETIME */}
                <div className="mt-16 flex justify-center">
                    <div className="relative group w-full max-w-md">
                        <div className="relative rounded-3xl bg-gradient-to-br from-yellow-400/20 via-yellow-500/15 to-orange-500/20 backdrop-blur-md border-2 border-yellow-400/50 p-6 md:p-8 flex flex-col transition-all duration-500 hover:shadow-2xl hover:scale-105 animate-slide-in-bottom">
                            {/* Badge "LIFETIME" en haut */}
                            <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-10">
                                <div className="bg-gradient-to-r from-yellow-400 to-orange-500 text-black text-xs font-bold uppercase tracking-wider px-6 py-2 rounded-full shadow-lg border-2 border-yellow-300 flex items-center gap-1">
                                    <Infinity className='w-5 h-5' /> <span>LIFETIME</span> <Infinity className='w-5 h-5' />
                                </div>
                            </div>
                            
                            {/* Effet de brillance animé */}
                            <div className="absolute inset-0 opacity-20">
                                <div className="absolute inset-0 bg-gradient-to-r from-transparent via-yellow-400/30 to-transparent animate-shimmer"></div>
                            </div>
                            
                            <div className="relative z-10">
                                {/* Header */}
                                <div className="text-center mb-6 mt-4">
                                    <h3 className="text-2xl md:text-3xl font-bold text-white mb-2">PLANO VITALÍCIO</h3>
                                    <p className="text-gray-200 text-sm">Acesso vitalício - Um único pagamento</p>
                                </div>

                                {/* Price */}
                                <div className="text-center mb-6">
                                    <div className="flex items-baseline justify-center gap-2">
                                        <span className="text-5xl md:text-6xl font-bold text-yellow-400">119.00€</span>
                                    </div>
                                    <p className="text-yellow-300 text-sm md:text-base mt-2 font-semibold">Pagamento único - Acesso permanente</p>
                                    <div className="mt-3 inline-block bg-yellow-400/20 text-yellow-300 px-4 py-1 rounded-full text-xs font-bold">
                                        ECONOMIZE MILHARES DE EUROS
                                    </div>
                                </div>
                                <div className="flex items-center justify-center gap-3 mt-2 mb-4">
                                    <div className='flex gap-1 items-center'>
                                        <svg xmlns="http://www.w3.org/2000/svg" className="text-yellow-400" width="24px" height="24px" viewBox="0 0 1920 1536"><path fill="currentColor" d="M1792 1120V160q0-13-9.5-22.5T1760 128H160q-13 0-22.5 9.5T128 160v960q0 13 9.5 22.5t22.5 9.5h1600q13 0 22.5-9.5t9.5-22.5m128-960v960q0 66-47 113t-113 47h-736v128h352q14 0 23 9t9 23v64q0 14-9 23t-23 9H544q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h352v-128H160q-66 0-113-47T0 1120V160Q0 94 47 47T160 0h1600q66 0 113 47t47 113"/></svg>
                                        <svg xmlns="http://www.w3.org/2000/svg" className="text-yellow-400" width="24px" height="24px" viewBox="0 0 1920 1536"><path fill="currentColor" d="M1792 1120V160q0-13-9.5-22.5T1760 128H160q-13 0-22.5 9.5T128 160v960q0 13 9.5 22.5t22.5 9.5h1600q13 0 22.5-9.5t9.5-22.5m128-960v960q0 66-47 113t-113 47h-736v128h352q14 0 23 9t9 23v64q0 14-9 23t-23 9H544q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h352v-128H160q-66 0-113-47T0 1120V160Q0 94 47 47T160 0h1600q66 0 113 47t47 113"/></svg>
                                    </div>
                                    <span className="text-yellow-400 text-md font-semibold">2 ecrãs</span>
                                </div>

                                {/* IBO gratuit */}
                                <div className="text-yellow-400 rounded-xl flex items-center justify-center gap-2 w-full py-2 px-4 mb-6 bg-yellow-400/10">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" viewBox="0 0 24 24">
                                        <path fill="currentColor" d="M19.435 5.568h-2.38a1.98 1.98 0 0 0-.51-1.92a2.02 2.02 0 0 0-2.83 0L12 5.367l-1.71-1.719a2 2 0 0 0-2.83 0a1.98 1.98 0 0 0-.51 1.92H4.565a1.5 1.5 0 0 0-1.5 1.5v1A1.49 1.49 0 0 0 4 9.448v8.99a2.507 2.507 0 0 0 2.5 2.5h11a2.5 2.5 0 0 0 2.5-2.5v-8.98a1.51 1.51 0 0 0 .94-1.39v-1a1.5 1.5 0 0 0-1.505-1.5M8.165 4.357a1 1 0 0 1 1.41 0l1.21 1.211h-2.77a.99.99 0 0 1 .15-1.211M11 19.938H6.5a1.5 1.5 0 0 1-1.5-1.5v-8.87h6Zm0-11.37H4.565a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5H11Zm3.43-4.211A1 1 0 0 1 16 5.568h-2.78ZM19 18.438a1.5 1.5 0 0 1-1.5 1.5H13V9.568h6Zm.94-10.37a.5.5 0 0 1-.5.5H13v-2h6.44a.5.5 0 0 1 .5.5Z"/>
                                    </svg>
                                    <span className="font-bold text-xs">+ Leitor IBO Pro grátis para sempre!</span>
                                </div>

                                {/* Features compactes */}
                                <div className="space-y-3 mb-6">
                                    <div className="flex items-center gap-3 text-sm">
                                        <svg className="w-4 h-4 text-yellow-400 flex-shrink-0" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill="currentColor" d="M9 16.17L4.83 12l-1.42 1.41L9 19l12-12l-1.41-1.41z"/></svg>
                                        <span className="text-gray-200">Todos os benefícios Premium + Gold</span>
                                    </div>
                                    <div className="flex items-center gap-3 text-sm">
                                        <svg className="w-4 h-4 text-yellow-400 flex-shrink-0" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill="currentColor" d="M9 16.17L4.83 12l-1.42 1.41L9 19l12-12l-1.41-1.41z"/></svg>
                                        <span className="text-gray-200">Acesso ilimitado vitalício</span>
                                    </div>
                                    <div className="flex items-center gap-3 text-sm">
                                        <svg className="w-4 h-4 text-yellow-400 flex-shrink-0" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill="currentColor" d="M9 16.17L4.83 12l-1.42 1.41L9 19l12-12l-1.41-1.41z"/></svg>
                                        <span className="text-gray-200">Atualizações gratuitas vitalícias</span>
                                    </div>
                                    <div className="flex items-center gap-3 text-sm">
                                        <svg className="w-4 h-4 text-yellow-400 flex-shrink-0" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill="currentColor" d="M9 16.17L4.83 12l-1.42 1.41L9 19l12-12l-1.41-1.41z"/></svg>
                                        <span className="text-gray-200">Suporte prioritário</span>
                                    </div>
                                    <div className="flex items-center gap-3 text-sm">
                                        <svg className="w-4 h-4 text-yellow-400 flex-shrink-0" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill="currentColor" d="M9 16.17L4.83 12l-1.42 1.41L9 19l12-12l-1.41-1.41z"/></svg>
                                        <span className="text-gray-200">30 Dias Garantia de Reembolso</span>
                                    </div>
                                </div>

                                {/* CTA Button */}
                                <button
                                    onClick={() => {
                                        window.location.href = "https://toptemplate.store/order.php?id=119";
                                    }}
                                    className="w-full bg-gradient-to-r from-yellow-400 to-orange-500 hover:from-yellow-300 hover:to-orange-400 text-black font-bold py-4 px-8 rounded-full transition-all duration-300 hover:scale-105 shadow-xl hover:shadow-2xl transform hover:-translate-y-1"
                                >
                                    <span className="flex items-center justify-center gap-2">
                                        <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5" viewBox="0 0 24 24"><path fill="currentColor" d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10s10-4.48 10-10S17.52 2 12 2m-2 15l-5-5l1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/></svg>
                                        Encomendar agora
                                    </span>
                                </button>

                                <div className="mt-4">
                                    <p className="text-white text-sm font-bold text-center">⚠️ Use o seu e-mail em vez do seu nome para receber os seus códigos de acesso e o guia de instalação</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Accept payment */}
                <div className="mt-16 mb-8">
                    <div className="text-center mb-8">
                        <h3 className="text-2xl md:text-3xl font-bold text-white mb-3">
                            Métodos de <span className="text-yellow-400">pagamento</span> aceites
                        </h3>
                        <p className="text-gray-400 text-sm md:text-base">
                            Pagamentos seguros e rápidos
                        </p>
                    </div>
                    
                    <div className="grid grid-cols-2 sm:grid-cols-3 md:flex md:flex-wrap md:justify-center gap-4 md:gap-6">
                        {paymentLogos.map((logo, index) => (
                            <div 
                                key={index}
                                className="group flex items-center justify-center p-4 md:p-6 bg-white/5 backdrop-blur-sm rounded-2xl border border-white/10 hover:bg-white/10 hover:border-yellow-400/30 transition-all duration-300 hover:scale-105 hover:shadow-lg w-full md:w-32"
                            >
                                <img 
                                    src={logo.src} 
                                    alt={logo.alt} 
                                    className={`h-8 md:h-10 w-full object-contain opacity-100 group-hover:opacity-110 transition-opacity duration-300 ${
                                        logo.useFilter ? 'filter brightness-0 invert' : ''
                                    }`}
                                />
                            </div>
                        ))}
                    </div>
                </div>

                {/* Bottom Banner - Contact WhatsApp pour Offre Spéciale */}
                <div className="mt-20 animate-slide-in-top">
                    <div className="relative overflow-hidden rounded-3xl bg-gradient-to-r from-yellow-400/10 via-yellow-400/5 to-blue-500/10 border border-yellow-400/30 p-8 md:p-10 shadow-2xl">
                        {/* Animated Background Pattern */}
                        <div className="absolute inset-0 opacity-10">
                            <div className="absolute inset-0" style={{
                                backgroundImage: `radial-gradient(circle at 30% 40%, rgba(34, 197, 94, 0.3) 0%, transparent 50%),
                                                radial-gradient(circle at 70% 60%, rgba(22, 163, 74, 0.3) 0%, transparent 50%)`,
                            }}></div>
                        </div>
                        
                        {/* Floating Animation Elements */}
                        <div className="absolute top-4 right-4 w-20 h-20 bg-green-400/20 rounded-full blur-2xl animate-pulse"></div>
                        <div className="absolute bottom-4 left-4 w-32 h-32 bg-green-500/10 rounded-full blur-3xl animate-pulse delay-1000"></div>
                        
                        <div className="relative z-10">
                            <div className="flex flex-col md:flex-row items-center justify-between gap-6 md:gap-8">
                                {/* Left Content */}
                                <div className="flex items-start gap-4 md:gap-6 flex-1">
                                    {/* WhatsApp Icon */}
                                    <div className="flex-shrink-0 w-16 h-16 md:w-20 md:h-20 bg-yellow-400 rounded-2xl flex items-center justify-center shadow-lg transform hover:scale-110 transition-transform duration-300">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="36px" height="36px" viewBox="0 0 24 24" className="text-white">
                                            <path fill="currentColor" d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967c-.273-.099-.471-.148-.67.15c-.197.297-.767.966-.94 1.164c-.173.199-.347.223-.644.075c-.297-.15-1.255-.463-2.39-1.475c-.883-.788-1.48-1.761-1.653-2.059c-.173-.297-.018-.458.13-.606c.134-.133.298-.347.446-.52c.149-.174.198-.298.298-.497c.099-.198.05-.371-.025-.52c-.075-.149-.669-1.612-.916-2.207c-.242-.579-.487-.5-.669-.51c-.173-.008-.371-.01-.57-.01c-.198 0-.52.074-.792.372c-.272.297-1.04 1.016-1.04 2.479c0 1.462 1.065 2.875 1.213 3.074c.149.198 2.096 3.2 5.077 4.487c.709.306 1.262.489 1.694.625c.712.227 1.36.195 1.871.118c.571-.085 1.758-.719 2.006-1.413c.248-.694.248-1.289.173-1.413c-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214l-3.741.982l.998-3.648l-.236-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884c2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/>
                                        </svg>
                                    </div>
                                    
                                    {/* Text Content */}
                                    <div className="flex-1">
                                        <h3 className="text-2xl md:text-3xl font-bold text-white mb-3">
                                            Precisa de uma <span className="text-yellow-400">Oferta Especial</span>?
                                        </h3>
                                        <p className="text-gray-200 text-sm md:text-base leading-relaxed mb-2">
                                            Contacte-nos diretamente no WhatsApp para discutir uma oferta personalizada adaptada às suas necessidades específicas.
                                        </p>
                                        <p className="text-yellow-400 font-semibold text-sm md:text-base">
                                            Resposta rápida garantida ⚡
                                        </p>
                                    </div>
                                </div>
                                
                                {/* CTA Button */}
                                <div className="flex-shrink-0 w-full md:w-auto">
                                    <a 
                                        href="https://wa.me/33759073683" 
                                        target="_blank" 
                                        rel="noopener noreferrer"
                                        className="inline-flex items-center justify-center gap-3 bg-yellow-400 hover:bg-yellow-300 text-white font-bold px-8 py-4 rounded-full transition-all duration-300 hover:scale-105 shadow-lg hover:shadow-xl w-full md:w-auto"
                                    >
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" className="text-white">
                                            <path fill="currentColor" d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967c-.273-.099-.471-.148-.67.15c-.197.297-.767.966-.94 1.164c-.173.199-.347.223-.644.075c-.297-.15-1.255-.463-2.39-1.475c-.883-.788-1.48-1.761-1.653-2.059c-.173-.297-.018-.458.13-.606c.134-.133.298-.347.446-.52c.149-.174.198-.298.298-.497c.099-.198.05-.371-.025-.52c-.075-.149-.669-1.612-.916-2.207c-.242-.579-.487-.5-.669-.51c-.173-.008-.371-.01-.57-.01c-.198 0-.52.074-.792.372c-.272.297-1.04 1.016-1.04 2.479c0 1.462 1.065 2.875 1.213 3.074c.149.198 2.096 3.2 5.077 4.487c.709.306 1.262.489 1.694.625c.712.227 1.36.195 1.871.118c.571-.085 1.758-.719 2.006-1.413c.248-.694.248-1.289.173-1.413c-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214l-3.741.982l.998-3.648l-.236-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884c2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/>
                                        </svg>
                                        <span>Contactar no WhatsApp</span>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}